export default __webpack_public_path__ + "static/media/chamberoflostdreams.f0f718a6.jpg";